import { SET_ORDERS_DATA } from './constants';

const initialState = {
  count: 0,
  orders: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ORDERS_DATA:
      return {
        ...state,
        orders: action.payload.orders,
        count: Math.ceil(Number(action.payload.count) / (Number(action.payload.pageSize) || 10)),
      };
    default:
      return state;
  }
};

export default reducer;